<template>
  <!--<div v-if="!item.hidden&&item.children" class="menu-wrapper">-->
  <div v-if="isShow(item) && item.children" class="menu-wrapper">

    <template
      v-if="hasOneShowingChild(item.children,item)">
      <app-link :to="resolvePath(onlyOneChild.path)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <item v-if="onlyOneChild.meta" :icon="onlyOneChild.meta.icon||item.meta.icon"
                :title="generateTitle(onlyOneChild.meta.title)"/>
        </el-menu-item>
      </app-link>
    </template>

    <el-submenu v-else ref="submenu" :index="resolvePath(item.path)">
      <template slot="title">
        <item v-if="item.meta" :icon="item.meta.icon" :title="generateTitle(item.meta.title)"/> 
      </template>

      <!--<template v-for="child in item.children" v-if="!child.hidden">-->
      <template v-for="child in item.children" >
        <sidebar-item
          v-if="child.children&&child.children.length>0"
          :is-nest="true"
          :item="child"
          :key="child.path"
          :base-path="resolvePath(child.path)"
          class="nest-menu"/>

        <app-link v-else :to="resolvePath(child.path)" :key="child.name" v-show="isShow(child)">
          <el-menu-item :index="resolvePath(child.path)">
            <item v-if="child.meta" :icon="child.meta.icon" :title="generateTitle(child.meta.title)"/>
          </el-menu-item>
        </app-link>
      </template>
    </el-submenu>

  </div>
</template>

<script>
  import path from 'path'
  import {generateTitle} from '@/utils/i18n'
  import {isExternal} from '@/utils'
  import Item from './Item'
  import AppLink from './Link'
  import FixiOSBug from './FixiOSBug'

  export default {
    name: 'SidebarItem',
    components: {
      Item, 
      AppLink
    },
    mixins: [FixiOSBug],
    props: { 
      item: {
        type: Object,
        required: true
      },
      isNest: {
        type: Boolean,
        default: false
      },
      basePath: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        onlyOneChild: null
      }
    },
    computed: {
      cursystem() {
        return this.$store.getters.cursystem
      },
    },
    methods: {
      isShow(menu) {
        if (menu === undefined || menu.menuid === undefined) {
          return false;
        }  
        if (this.cursystem !== menu.systemtypeid) {
          return false;
        }
        //  console.log(JSON.stringify(menu));
        return this.$store.getters.userRemoteMenuIds.indexOf(menu.menuid) !== -1;
      },
      hasOneShowingChild(children, parent) {
        return false;
        // const showingChildren = children.filter(item => {
        //   if (!this.isShow(item)) {
        //     return false
        //   } else {
        //     // Temp set(will be used if only has one showing child)
        //     this.onlyOneChild = item
        //     return true
        //   }
        // })

        // // When there is only one child router, the child router is displayed by default
        // if (showingChildren.length === 1) {
        //   return true
        // }

        // // Show parent if there are no child router to display
        // if (showingChildren.length === 0) {
        //   this.onlyOneChild = {...parent, path: '', noShowingChildren: true}
        //   return true
        // }
        // return false
      },
      resolvePath(routePath) {
        if (this.isExternalLink(routePath)) {
          return routePath
        }
        return path.resolve(this.basePath, routePath)
      },
      isExternalLink(routePath) {
        return isExternal(routePath)
      },
      generateTitle
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue